import URLS from '@/store/urls';
import notificationWithIcon from '@/utils/notification';
import apiCall from '@/store/apiCall';
import axios from 'axios';
import types from './types';

const actions = {
  async getTemplateCollections({ commit }) {
    try {
      commit(types.GET_OPTIONS_START);
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: URLS.frameTemplateCollections,
        isToken: true,
      });
      commit(types.GET_OPTIONS_SUCCESS, data);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
      commit(types.GET_OPTIONS_FAILURE, message);
    }
  },
  async createTemplateCollection({ dispatch }, payload) {
    try {
      const { collection, file } = payload;
      if (file) {
        const frameImageData = new FormData();
        frameImageData.append('file', file);
        frameImageData.append('folder', 'default');
        const { data: { data: { url, key } } } = await apiCall({
          type: 'POST',
          url: URLS.fileUpload,
          headers: { 'content-type': 'multipart/form-data' },
          body: frameImageData,
          isToken: true,
        });
        collection.imageKey = key;
        collection.imageUri = url;
      }
      await apiCall({
        type: 'POST',
        url: URLS.frameTemplateCollections,
        isToken: true,
        body: collection,
      });
      notificationWithIcon('success', 'Collection created');
      dispatch('getTemplateCollections');
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async updateTemplateCollectionOrder({ dispatch }, payload) {
    try {
      await apiCall({
        type: 'PUT',
        url: URLS.frameTemplateCollections,
        isToken: true,
        body: payload,
      });
      notificationWithIcon('success', 'Collection order updated');
      dispatch('getTemplateCollections');
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async updateTemplateCollection({ dispatch }, payload) {
    try {
      const { collection, file } = payload;
      if (file) {
        const frameImageData = new FormData();
        frameImageData.append('file', file);
        frameImageData.append('folder', 'default');
        const { data: { data: { url, key } } } = await apiCall({
          type: 'POST',
          url: URLS.fileUpload,
          headers: { 'content-type': 'multipart/form-data' },
          body: frameImageData,
          isToken: true,
        });
        collection.imageKey = key;
        collection.imageUri = url;
      }
      await apiCall({
        type: 'PUT',
        url: URLS.frameTemplateCollections,
        isToken: true,
        body: [collection],
      });
      notificationWithIcon('success', 'Collection updated');
      dispatch('getTemplateCollections');
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async deleteTemplateCollection({ dispatch }, id) {
    try {
      await apiCall({
        type: 'DELETE',
        url: `${URLS.frameTemplateCollections}/${id}`,
        isToken: true,
      });
      notificationWithIcon('success', 'Collection deleted');
      dispatch('getTemplateCollections');
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async getTemplateCollectionsFrames({ commit }) {
    try {
      const [frames, collages] = await Promise.all([
        apiCall({
          type: 'GET',
          url: URLS.createTemplateFrames,
          isToken: true,
        }),
        apiCall({
          type: 'GET',
          url: URLS.collage,
          isToken: true,
        }),
      ]);
      commit(types.GET_COLLECTION_FRAMES_SUCCESS, [...frames.data.data, ...collages.data.data]);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async templateFrame({ dispatch }, payload) {
    try {
      const {
        frame,
        file,
        type,
        id,
        name,
      } = payload;
      const apiPostUrl = name === 'photo_art' ? URLS.photoArtDetails : URLS.collage;
      const { data: { data } } = await apiCall({
        type,
        url: type === 'POST' ? apiPostUrl : `${URLS.product}/${id}`,
        isToken: true,
        body: frame,
      });
      if (file) {
        const frameImageData = new FormData();
        frameImageData.append('file', file);
        frameImageData.append('folder', 'frame-placeholder-images');
        const { data: { data: { url } } } = await apiCall({
          type: 'POST',
          url: URLS.fileUpload,
          headers: { 'content-type': 'multipart/form-data' },
          body: frameImageData,
          isToken: true,
        });
        await apiCall({
          type: 'PUT',
          url: `${URLS.product}/${data.id}`,
          isToken: true,
          body: {
            imageUri: url,
          },
        });
      }
      const successMessage = type === 'POST' ? 'Frame created' : 'Frame updated';
      notificationWithIcon('success', successMessage);
      dispatch('getTemplateCollectionsFrames');
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async deleteTemplateFrame({ dispatch }, payload) {
    try {
      const { id, name } = payload;
      const apiPostUrl = name === 'photo_art' ? URLS.photoArtDetails : URLS.collage;
      await apiCall({
        type: 'DELETE',
        url: `${apiPostUrl}/${id}`,
        isToken: true,
      });
      notificationWithIcon('success', 'Frame deleted');
      dispatch('getTemplateCollectionsFrames');
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async getFrameDetails({ commit }, id) {
    try {
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: `${URLS.product}/${id}`,
        isToken: true,
      });
      commit(types.GET_FRAME_DETAILS_SUCCESS, data);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async getHintMedia({ commit }, id) {
    try {
      console.log('[Action] getHintMedia - fetching for id:', id);
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: `${URLS.getHintImages}/${id}`,
        isToken: true,
      });
      console.log('[Action] getHintMedia - received data:', data);
      commit('GET_HINT_MEDIA_SUCCESS', data);
    } catch (e) {
      console.error('[Action] getHintMedia - error:', e);
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async editImageContent({ dispatch }, payload) {
    const {
      deletedMedia = [],
      newMedia = [],
      id,
    } = payload;
    console.log('[Action] editImageContent - payload:', { deletedMedia, newMedia, id });
    try {
      // Удаляем только те картинки, которые были удалены пользователем
      if (deletedMedia.length > 0) {
        console.log('[Action] editImageContent - deleting removed media:', deletedMedia);
        await Promise.all(deletedMedia.map(async ({ id: imageId }) => {
          console.log('[Action] editImageContent - deleting image id:', imageId);
          await apiCall({
            type: 'DELETE',
            url: `${URLS.hintImage}/${imageId}`,
            isToken: true,
          });
        }));
      }

      // Загружаем ВСЕ новые файлы
      if (newMedia.length > 0) {
        console.log('[Action] editImageContent - uploading new media:', newMedia);
        await Promise.all(newMedia.map(async (mediaItem, index) => {
          const formData = new FormData();
          formData.append('file', mediaItem.file);
          formData.append('productId', id);
          formData.append('index', String(index));
          console.log('[Action] editImageContent - uploading file:', mediaItem.file.name);
          await apiCall({
            type: 'POST',
            url: `${URLS.hintImage}/product`,
            headers: { 'content-type': 'multipart/form-data' },
            body: formData,
            isToken: true,
          });
        }));
        console.log('[Action] editImageContent - all uploads successful');
      }

      notificationWithIcon('success', 'Frame\'s hint updated');
      dispatch('getHintMedia', id);
    } catch (err) {
      console.error('[Action] editImageContent - error:', err);
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
    }
  },
  async editIframeContent({ dispatch }, payload) {
    try {
      const {
        iframe,
        oldMedia,
        productId,
        ...rest
      } = payload;
      await Promise.all(oldMedia.map(async ({ id: imageId }) => {
        await apiCall({
          type: 'DELETE',
          url: `${URLS.hintImage}/${imageId}`,
          isToken: true,
        });
      }));
      await apiCall({
        type: 'POST',
        url: `${URLS.hintImage}/product/iframe`,
        body: {
          iFrame: iframe,
          productId,
          ...rest,
        },
        isToken: true,
      });
      notificationWithIcon('success', 'Hint updated');
      dispatch('getHintMedia', productId);
    } catch (err) {
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
    }
  },
  async getFrameOptions({ commit }, payload) {
    try {
      const { id, type } = payload;
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: `${type === 'photo_art' ? URLS.photoArtDetails : URLS.collage}/${id}/options`,
        isToken: true,
      });
      commit(types.GET_FRAME_OPTIONS_SUCCESS, data);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async updateFrameOption({ dispatch }, payload) {
    try {
      const {
        option,
        optionId,
        productId,
        type,
      } = payload;
      await apiCall({
        type: 'PUT',
        url: `${URLS.photoArtDetails}/${productId}/options/${optionId}`,
        body: option,
        isToken: true,
      });
      notificationWithIcon('success', 'Option updated');
      dispatch('getFrameOptions', { id: productId, type });
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async updateFrameOptions({ dispatch }, payload) {
    try {
      const { options, productId, type } = payload;
      await Promise.all(options.map(({ option, optionId }) => apiCall({
        type: 'PUT',
        url: `${URLS.photoArtDetails}/${productId}/options/${optionId}`,
        body: option,
        isToken: true,
      })));
      notificationWithIcon('success', 'Options updated');
      dispatch('getFrameOptions', { id: productId, type });
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async getFrameSizes({ commit }) {
    try {
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: URLS.sizes,
        isToken: true,
      });
      commit(types.GET_FRAME_SIZES_SUCCESS, data);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async createFrameSize({ dispatch }, payload) {
    try {
      const {
        body,
      } = payload;
      await apiCall({
        type: 'POST',
        url: URLS.sizes,
        body,
        isToken: true,
      });
      notificationWithIcon('success', 'Frame size created');
      dispatch('getFrameSizes');
    } catch (e) {
      const {
        response: {
          data: {
            message: serverMessage = '',
          } = {},
        } = {},
        message: axiosMessage,
      } = e || {};
      const message = serverMessage || axiosMessage || '';
      notificationWithIcon('error', message);
    }
  },
  async editFrameSize({ dispatch }, payload) {
    try {
      const {
        id,
        body,
      } = payload;
      await apiCall({
        type: 'PUT',
        url: `${URLS.sizes}/${id}`,
        body,
        isToken: true,
      });
      notificationWithIcon('success', `Frame sizes ${body.name || ''} updated`);
      dispatch('getFrameSizes');
    } catch (e) {
      const {
        response: {
          data: {
            message: serverMessage = '',
          } = {},
        } = {},
        message: axiosMessage,
      } = e || {};
      const message = serverMessage || axiosMessage || '';
      notificationWithIcon('error', message);
    }
  },
  async deleteFrameSize({ dispatch }, payload) {
    try {
      await apiCall({
        type: 'DELETE',
        url: `${URLS.sizes}/${payload}`,
        isToken: true,
      });
      notificationWithIcon('success', 'Frame size deleted');
      dispatch('getFrameSizes');
    } catch (e) {
      const {
        response: {
          data: {
            message: serverMessage = '',
          } = {},
        } = {},
        message: axiosMessage,
      } = e || {};
      const message = serverMessage || axiosMessage || '';
      notificationWithIcon('error', message);
    }
  },
  async getFrameColors({ commit }) {
    try {
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: URLS.colors,
        isToken: true,
      });
      commit(types.GET_FRAME_COLORS_SUCCESS, data);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async editFrameColor({ dispatch }, payload) {
    try {
      const {
        id,
        body,
      } = payload;
      await apiCall({
        type: 'PUT',
        url: `${URLS.colors}/${id}`,
        body,
        isToken: true,
      });
      notificationWithIcon('success', `Frame color ${body.name || ''} updated`);
      dispatch('getFrameColors');
    } catch (e) {
      const {
        response: {
          data: {
            message: serverMessage = '',
          } = {},
        } = {},
        message: axiosMessage,
      } = e || {};
      const message = serverMessage || axiosMessage || '';
      notificationWithIcon('error', message);
    }
  },
  async createFrameColor({ dispatch }, payload) {
    try {
      const {
        body,
      } = payload;
      await apiCall({
        type: 'POST',
        url: `${URLS.colors}`,
        body,
        isToken: true,
      });
      notificationWithIcon('success', 'Frame color created');
      dispatch('getFrameColors');
    } catch (e) {
      const {
        response: {
          data: {
            message: serverMessage = '',
          } = {},
        } = {},
        message: axiosMessage,
      } = e || {};
      const message = serverMessage || axiosMessage || '';
      notificationWithIcon('error', message);
    }
  },
  async deleteFrameColor({ dispatch }, payload) {
    try {
      await apiCall({
        type: 'DELETE',
        url: `${URLS.colors}/${payload}`,
        isToken: true,
      });
      notificationWithIcon('success', 'Frame color deleted');
      dispatch('getFrameColors');
    } catch (e) {
      const {
        response: {
          data: {
            message: serverMessage = '',
          } = {},
        } = {},
        message: axiosMessage,
      } = e || {};
      const message = serverMessage || axiosMessage || '';
      notificationWithIcon('error', message);
    }
  },
  async createFrameOption({ dispatch }, payload) {
    try {
      const { option, frameId, type } = payload;
      const url = type === 'photo_art'
        ? `${URLS.photoArtDetails}/${frameId}/options`
        : `${URLS.collage}/${frameId}/option`;
      await apiCall({
        type: 'POST',
        url,
        body: option,
        isToken: true,
      });
      notificationWithIcon('success', 'Option created');
      dispatch('getFrameOptions', { id: frameId, type });
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async deleteFrameOption({ dispatch }, payload) {
    try {
      const { optionId, frameId, type } = payload;
      await apiCall({
        type: 'DELETE',
        url: `${URLS.photoArtDetails}/${frameId}/options/${optionId}`,
        isToken: true,
      });
      notificationWithIcon('success', 'Option deleted');
      dispatch('getFrameOptions', { id: frameId, type });
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async updateOrCreateFrameDisplay({ dispatch }, payload) {
    try {
      const {
        display,
        frameImageUri,
        baseImageUri,
        id,
        productId,
      } = payload;
      if (frameImageUri.file) {
        const frameImageData = new FormData();
        frameImageData.append('file', frameImageUri.file);
        frameImageData.append('folder', 'custom-background');
        const { data: { data: { url, key } } } = await apiCall({
          type: 'POST',
          url: URLS.fileUpload,
          headers: { 'content-type': 'multipart/form-data' },
          body: frameImageData,
          isToken: true,
        });
        display.frameImageUri = url;
        display.frameImageKey = key;
      }

      if (baseImageUri.file) {
        const baseImageData = new FormData();
        baseImageData.append('file', baseImageUri.file);
        baseImageData.append('folder', 'custom-background');
        const { data: { data: { url, key } } } = await apiCall({
          type: 'POST',
          url: URLS.fileUpload,
          headers: { 'content-type': 'multipart/form-data' },
          body: baseImageData,
          isToken: true,
        });
        display.baseImageUri = url;
        display.baseImageKey = key;
        display.fullDisplay = {
          ...display.fullDisplay,
          imageUri: url,
          imageKey: key,
        };
        display.liveDisplay = {
          ...display.liveDisplay,
          imageUri: url,
          imageKey: key,
        };
        display.minDisplay = {
          ...display.minDisplay,
          imageUri: url,
          imageKey: key,
        };
        display.mobileDisplay = {
          ...display.mobileDisplay,
          imageUri: url,
          imageKey: key,
        };
      }
      if (id) {
        await apiCall({
          type: 'PUT',
          url: `${URLS.frameDisplay}/${id}`,
          isToken: true,
          body: display,
        });
        notificationWithIcon('success', 'Display updated');
        dispatch('getFrameOptionDisplays', { productId });
      } else {
        await apiCall({
          type: 'POST',
          url: `${URLS.frameDisplay}`,
          isToken: true,
          body: display,
        });
        notificationWithIcon('success', 'Display created');
        dispatch('getFrameOptionDisplays', { productId });
      }
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async updateDisplayPosition({ dispatch }, payload) {
    try {
      const { productId, displays } = payload;
      await Promise.all(displays.map(({ id: displayId, ...display }) => apiCall({
        type: 'PUT',
        url: `${URLS.frameDisplay}/${displayId}`,
        body: display,
        isToken: true,
      })));
      notificationWithIcon('success', 'Collection order updated');
      dispatch('getFrameOptionDisplays', { productId });
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async deleteFrameDisplay({ dispatch }, payload) {
    try {
      const {
        id,
        productId,
      } = payload;
      await apiCall({
        type: 'DELETE',
        url: `${URLS.frameDisplay}/${id}`,
        isToken: true,
      });
      dispatch('getFrameOptionDisplays', { productId });
      notificationWithIcon('success', 'Display deleted');
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async getFrameOptionDisplays({ commit }, payload) {
    try {
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: `${URLS.frameOptionDisplays}`,
        params: payload,
        isToken: true,
      });
      commit(types.GET_OPTION_DISPLAYS_SUCCESS, data);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async updateFrameDisplayPersonalize(_, payload) {
    try {
      const { id, ...rest } = payload;
      await apiCall({
        type: 'PUT',
        url: `${URLS.frameOptionDisplays}/personalize/${id}`,
        isToken: true,
        body: {
          personalize: rest,
        },
      });
      notificationWithIcon('success', `Personalize ${payload.name} updated`);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async createFrameDisplayPersonalize(_, payload) {
    try {
      const { id, ...rest } = payload;
      await apiCall({
        type: 'POST',
        url: `${URLS.frameOptionDisplays}/personalize/`,
        isToken: true,
        body: {
          personalize: rest,
          frameDisplayId: id,
        },
      });
      notificationWithIcon('success', `Personalize ${payload.name} created`);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async deleteFrameDisplayPersonalize(_, payload) {
    try {
      const { id } = payload;
      await apiCall({
        type: 'DELETE',
        url: `${URLS.frameOptionDisplays}/personalize/${id}`,
        isToken: true,
      });
      notificationWithIcon('success', 'Personalize deleted');
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async getCollagePreviewImages({ commit }, id) {
    try {
      commit(types.GET_COLLAGE_PREVIEW_IMAGES_START);
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: `${URLS.productPreviewImages}/product/${id}`,
        isToken: true,
      });
      commit(types.GET_COLLAGE_PREVIEW_IMAGES_SUCCESS, data);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
      commit(types.GET_COLLAGE_PREVIEW_IMAGES_FAILURE, message);
    }
  },
  async postCollagePreviewImages({ commit, dispatch }, payload) {
    const { imageNames, images, productId } = payload;
    try {
      commit(types.POST_COLLAGE_PREVIEW_IMAGES_START);
      const { data: { data: urls } } = await apiCall({
        type: 'POST',
        body: { imageNames, productId },
        url: URLS.productPreviewImages,
        isToken: true,
      });
      await Promise.all(urls.map(({ uploadUrl }, index) => axios.put(uploadUrl, images[index])));
      commit(types.POST_COLLAGE_PREVIEW_IMAGES_SUCCESS);
      dispatch('getCollagePreviewImages', productId);
      notificationWithIcon('success', 'Images added');
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
      commit(types.POST_COLLAGE_PREVIEW_IMAGES_FAILURE, message);
    }
  },
  async deleteCollagePreviewImage({ commit, dispatch }, payload) {
    try {
      commit(types.DELETE_COLLAGE_PREVIEW_IMAGE_START);
      const { id, productId, withUpdateList } = payload;
      await apiCall({
        type: 'DELETE',
        url: `${URLS.productPreviewImages}/${id}`,
        isToken: true,
      });
      commit(types.DELETE_COLLAGE_PREVIEW_IMAGE_SUCCESS);
      if (withUpdateList) {
        dispatch('getCollagePreviewImages', productId);
      }
      notificationWithIcon('success', 'Image deleted');
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
      commit(types.DELETE_COLLAGE_PREVIEW_IMAGE_FAILURE);
    }
  },
  async getProductCustomSizeSettings({ commit }, productId) {
    try {
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: `${URLS.productCustomSizeSettings}/${productId}`,
        isToken: true,
      });
      commit(types.GET_CUSTOM_SIZE_SETTINGS_SUCCESS, data);
    } catch (e) {
      // 404 = no settings exist yet, that's OK
      if (e.response?.status !== 404) {
        const { response: { data: { message } } = { data: { message: e.message } } } = e;
        notificationWithIcon('error', message);
      }
      commit(types.GET_CUSTOM_SIZE_SETTINGS_SUCCESS, null);
    }
  },
  async saveProductCustomSizeSettings({ dispatch }, payload) {
    try {
      const { productId, settings, isNew } = payload;
      const body = {
        price_per_sq_inch: settings.price_per_sq_inch,
        base_price: settings.base_price,
        min_width: settings.min_width,
        max_width: settings.max_width,
        min_height: settings.min_height,
        max_height: settings.max_height,
        min_aspect_ratio: settings.min_aspect_ratio,
        max_aspect_ratio: settings.max_aspect_ratio,
        optimal_ppi: settings.optimal_ppi,
        is_enabled: settings.is_enabled,
      };
      // product_id is only needed for POST (create), not for PUT (update)
      if (isNew) {
        body.product_id = productId;
      }
      await apiCall({
        type: isNew ? 'POST' : 'PUT',
        url: isNew
          ? URLS.productCustomSizeSettings
          : `${URLS.productCustomSizeSettings}/${settings.id}`,
        body,
        isToken: true,
      });
      notificationWithIcon('success', 'Custom size settings saved');
      dispatch('getProductCustomSizeSettings', productId);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async deleteProductCustomSizeSettings({ dispatch }, payload) {
    try {
      const { id, productId } = payload;
      await apiCall({
        type: 'DELETE',
        url: `${URLS.productCustomSizeSettings}/${id}`,
        isToken: true,
      });
      notificationWithIcon('success', 'Custom size settings deleted');
      dispatch('getProductCustomSizeSettings', productId);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  // Tree state actions — thin wrappers for commit
  setTreeSelectedNode({ commit }, key) {
    commit(types.SET_TREE_SELECTED_NODE, key);
  },
  setTreeExpandedKeys({ commit }, keys) {
    commit(types.SET_TREE_EXPANDED_KEYS, keys);
  },
};
export default actions;
